import orderBy from 'lodash/orderBy';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IApiList, IGetJobTitleOptions, IGetOrgJobTitleOptions } from 'types';
import * as API from '../../../api';
import { IJobTitleState } from '../../types';
import * as Actions from './actions';
import * as ActionTypes from './types';

export function* getJobTitles({ payload }: IAction<ActionTypes.JobTitles, IGetJobTitleOptions>) {
  try {
    const response: ApiResponse<IApiList<IJobTitleState>> = yield call(API.Sites.listJobs, payload.siteId, payload.sources);
    const data = orderBy(response.body.data, [(job) => job.title.toLowerCase()], ['asc']);
    yield put(Actions.getJobTitlesSuccess({ siteId: payload.siteId, response: data }));
  } catch (error: any) {
    yield put(Actions.getJobTitlesError(error));
  }
}

export function* getOrgJobTitles({ payload }: IAction<ActionTypes.JobTitles, IGetOrgJobTitleOptions>) {
  try {
    const response: ApiResponse<IApiList<IJobTitleState>> = yield call(API.Organizations.getJobs, payload.organizationId, payload.includeInactive);
    const data = orderBy(response.body.data, [(job) => job.title.toLowerCase()], ['asc']);
    yield put(Actions.getOrgJobTitlesSuccess({ organizationId: payload.organizationId, response: data }));
  } catch (error: any) {
    yield put(Actions.getOrgJobTitlesError(error));
  }
}

export function* watchGetJobTitles() {
  yield takeEvery(ActionTypes.JobTitles.GET_JOB_TITLES_REQUEST, getJobTitles);
}

export function* watchOrgGetJobTitles() {
  yield takeEvery(ActionTypes.JobTitles.GET_ORG_JOB_TITLES_REQUEST, getOrgJobTitles);
}

function* jobTitlesSaga() {
  yield all([fork(watchGetJobTitles), fork(watchOrgGetJobTitles)]);
}
export { jobTitlesSaga };
